/*
 * サブシステム名：マスタ管理
 * 機能名：権限設定一覧
 */

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import filter from '@/rahmen/utils/filters'

const DdSearchList = () => import('@/components/DdSearchList')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'MstKengenList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    conditions: {
      kengenGroupCd: '',
      kengenGroupNm: ''
    },
    modeKengen: 0
  }),
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      menuList: 'DDMasters/msysMenu',
      menuDetailList: 'DDMasters/msysMenuDetail',
      kinoList: 'DDMasters/msysKino'
    }),
    filteredMenuList () {
      const self = this
      const result = self.menuList.map((m) => {
        m.listDisplay = self.menuDetailList.filter((d) => {
          return d.mstMenuId === m.id
        }).map((d) => {
          const kino = self.kinoList.find((k) => {
            return d.mstKinoId === k.id
          })
          d.kinoNm = kino ? kino.kinoNm : ''
          d.viewNm = kino ? kino.viewNm : ''
          return d
        }).sort((a, b) => {
          if (a.hyojiOrder < b.hyojiOrder) { return -1 }
          if (a.hyojiOrder > b.hyojiOrder) { return 1 }
          return 0
        })
        return m
      })
        .sort((a, b) => {
          if (a.hyojiOrder < b.hyojiOrder) { return -1 }
          if (a.hyojiOrder > b.hyojiOrder) { return 1 }
          return 0
        })
      return result
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msysmenudetail', 'msyskino'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstKengenList.defineHeaderPromise')
            var headerList = []
            var headerData = {}
            self.filteredMenuList.forEach(function (item) {
              item.listDisplay.forEach(function (itemLists) {
                headerData = {}
                headerData.text = itemLists.kinoNm
                headerData.value = 'key_' + itemLists.mstKinoId
                headerList.push(headerData)
              })
            })
            headerData = {}
            headerData.text = '表示順'
            headerData.value = 'hyojiOrderDisp'
            headerData.align = 'end'
            headerList.push(headerData)
            headerData = {}
            headerData.text = '権限グループ名称'
            headerData.value = 'kengenGroupNm'
            headerList.unshift(headerData)
            headerData = {}
            headerData.text = '権限グループコード'
            headerData.value = 'kengenGroupCd'
            headerList.unshift(headerData)
            headerData = {}
            headerData.text = '編集'
            headerData.value = 'actions'
            headerData.sortable = false
            headerData.width = '20px'
            headerList.unshift(headerData)

            self.headers = headerList
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              kengenGroupCd: '',
              kengenGroupNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstKengenList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstKengenList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstKengenList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstKengenList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstKengenList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstKengenGroup/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              kengenGroupCd: '',
              kengenGroupNm: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    onDummyFunction: function () {
      return null
    }
  }
}
